import { state } from './state.js';
import * as UI from './ui.js';

export function initZoom() {
    const zoomModal = document.getElementById('zoomModal');
    const zoomImg = document.getElementById('zoomModalImg');
    const tooltip = document.getElementById('xrayTooltip');

    let scale = 1;
    let pointX = 0;
    let pointY = 0;
    let isPanning = false;
    let startX = 0;
    let startY = 0;

    const reset = () => {
        const cw = window.innerWidth;
        const ch = window.innerHeight;
        const iw = zoomImg.naturalWidth;
        const ih = zoomImg.naturalHeight;

        if (!iw || !ih) return;

        const scaleW = cw / iw;
        const scaleH = ch / ih;
        scale = Math.min(scaleW, scaleH) * 0.95;

        pointX = 0;
        pointY = 0;

        updateTransform();
    };

    document.addEventListener('resetZoom', reset);

    document.addEventListener('keydown', (e) => {
        if (e.key === "Escape" && !zoomModal.classList.contains('hidden')) {
            UI.toggleModal(false); //
        }
    });

    // Click anywhere outside the image to close (behaves like the X)
    zoomModal.addEventListener('click', (e) => {
        if (e.target !== zoomImg) {
            UI.toggleModal(false);
        }
    });

    // Prevent image clicks from bubbling to the modal close handler.
    zoomImg.addEventListener('click', (e) => e.stopPropagation());

    zoomModal.addEventListener('wheel', (e) => {
        e.preventDefault();
        const zoomIntensity = 0.15;
        const delta = e.deltaY > 0 ? -zoomIntensity : zoomIntensity;
        const newScale = scale * (1 + delta);

        if (newScale < 0.01 || newScale > 50) return;

        const mouseX = e.clientX - window.innerWidth / 2;
        const mouseY = e.clientY - window.innerHeight / 2;

        pointX -= (mouseX - pointX) * delta;
        pointY -= (mouseY - pointY) * delta;

        scale = newScale;
        updateTransform();
    }, { passive: false });

    zoomImg.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        isPanning = true;
        startX = e.clientX - pointX;
        startY = e.clientY - pointY;
        zoomImg.style.cursor = 'grabbing';
    });

    window.addEventListener('mousemove', (e) => {
        if (isPanning) {
            pointX = e.clientX - startX;
            pointY = e.clientY - startY;
            updateTransform();
            return;
        }

        // TOOLTIP LOOKUP
        if (zoomModal.classList.contains('hidden') || !state.tileMap || state.tileMap.length === 0) {
            tooltip.classList.add('hidden');
            return;
        }

        const rect = zoomImg.getBoundingClientRect();
        const relX = e.clientX - rect.left;
        const relY = e.clientY - rect.top;

        // 1. Get position relative to the DISPLAYED image (e.g. the 6000px inspect image)
        let lookupX = (relX / rect.width) * zoomImg.naturalWidth;
        let lookupY = (relY / rect.height) * zoomImg.naturalHeight;

        // 2. FIX: SCALE UP TO ORIGINAL RESOLUTION
        // The tileMap coordinates are always in the Full Resolution (e.g. 20,000px).
        // If we are looking at a downscaled "Inspect" image, we must multiply our mouse coords.
        if (state.lastShownSettings && state.lastShownSettings.w_final && state.lastShownSettings.h_final) {
            const fullW = parseInt(state.lastShownSettings.w_final);
            const fullH = parseInt(state.lastShownSettings.h_final);

            // Avoid division by zero or weirdness
            if (fullW > 0 && zoomImg.naturalWidth > 0) {
                const ratioX = fullW / zoomImg.naturalWidth;
                const ratioY = fullH / zoomImg.naturalHeight;

                lookupX *= ratioX;
                lookupY *= ratioY;
            }
        }

        const tile = state.tileMap.find(t =>
            lookupX >= t.x && lookupX < t.x + t.w &&
            lookupY >= t.y && lookupY < t.y + t.h
        );

        if (tile) {
            tooltip.classList.remove('hidden');
            tooltip.style.left = (e.clientX + 20) + "px";
            tooltip.style.top = (e.clientY + 20) + "px";

            const cleanName = tile.file.includes('_') ? tile.file.split('_').slice(1).join('_') : tile.file;
            document.getElementById('xrayName').innerText = cleanName;
            document.getElementById('xrayCoords').innerText = `X: ${Math.round(tile.x)} | Y: ${Math.round(tile.y)}`;
        } else {
            tooltip.classList.add('hidden');
        }
    });

    window.addEventListener('mouseup', () => {
        isPanning = false;
        zoomImg.style.cursor = 'grab';
    });

    function updateTransform() {
        zoomImg.style.transform = `translate(${pointX}px, ${pointY}px) scale(${scale})`;
    }
}